module.exports = __webpack_public_path__ + "static/media/roi3.2d1632b3.png";